import React from "react";
import Logo from "./Logo";
import "./Section.css";
import {APKLink, GoogleStoreLink, HuaweiLink, SamsungLink, XiaomiLink} from "./Links";

const SectionTr = () => {
  return (
    <section className="app-section">
      <h1>Tango Nasıl Kurulur: Adım Adım Kılavuz</h1>
      <h5>Canlı Yayına Geç. Bağlan. Keyfini Çıkar – Her Zaman, Her Yerde!</h5>
      <div className="icon-section">
        <Logo />
        <div className="icon-section__text">
          <span>Yazar: Tango</span>
          <span>Bugün güncellendi</span>
        </div>
      </div>
      <p>
        <b>
          Tango, birden fazla platformda mevcut olup, istediğiniz zaman ve yerde canlı yayın yapmayı ve canlı eğlencenin keyfini çıkarmayı kolaylaştırır.
        </b>
      </p>
      <hr />
      <h2>🤖 Android Kullanıcıları için:</h2>
      <p>
        Tango'yu doğrudan şu platformlardan indirebilirsiniz:
      </p>
      <ul>
        <li>
          <GoogleStoreLink text={"Google Play Store"}/>
        </li>
        <li>
          <XiaomiLink/>
        </li>
        <li>
          <HuaweiLink/>
        </li>
        <li>
          <SamsungLink/>
        </li>
      </ul>
      <hr />
      <br />
      <h2> iOS Kullanıcıları için:</h2>
      <p>
        <b>
          Daha önce Tango'yu iOS cihazınıza yüklediyseniz, App Store'dan tekrar indirebilirsiniz.
        </b>
      </p>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/TQkbk0cvsxE?si=e5ZqM_EWiJe9F01R"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>1. App Store'u Açın: iOS cihazınızda App Store'a girin.</p>
      <p>
        2. Profil Resminize Dokunun: Hesap ayarlarınıza erişmek için Eekranın sağ üst köşesindeki profil resminize dokunarakun . hesap ayarlarınıza erişin.
      </p>
      <p>
        3. ‘Uygulamalar’ veya ‘Satın Alma Geçmişi’ne gidin: Daha önce satın aldığınız uygulamaların listesini gözden geçirin veya üstteki arama çubuğunu kullanarak "Tango"yu arayın.
      </p>
      <p>
        4. Tango'yu Tekrar İndirin: Listede Tango'yu bulduğunuzda, yanındaki bulut simgesine dokunarak uygulamayı tekrar indirin.
      </p>
      <p>
        5. Yükleme Sonrasında Tango Uygulamasını Açın: Kayıt veya giriş sürecini takip edin.
      </p>
      <hr />
      <h2>Tango'da yeni misiniz? Hızlı erişim için Tango’yu kolayca ana ekranınıza ekleyin</h2>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/iM15aUI94Yo?si=qee02UWPVKEXtDdF"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        Tango'nun Web Sitesini Açın: <a href="https://tngrenkli.me/">https://tngrenkli.me/</a> bağlantısını mobil tarayıcınızda açın.
      </p>
      <p>
        Paylaşım Simgesine Dokunun: Ekranın altındaki yukarı ok işaretli kare simgesine dokunun.
      </p>
      <p>
        "Ana Ekrana Ekle"yi Seçin: Menüden bu seçeneği seçin ve Tango kısayolu cihazınızın ana ekranına eklenecektir.
      </p>
      <p>Yükleme tamamlandıktan sonra, canlı yayına geçmeye, favori içerik oluşturucularınızı desteklemeye ve sonsuz eğlencenin tadını çıkarmaya hazırsınız – hepsi parmaklarınızın ucunda!</p>
      <br/>
      <b>Hemen başlayın ve aksiyona katılın! 🎉</b>
    </section>
  );
};

export default SectionTr;
